function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { AverageStarRatingAndTotal } from '@domain-group/fe-co-allhomes-average-star-rating-and-total';
import { Loader } from '@domain-group/fe-blueprint-ui/loader';
import { AlertIcon } from '@domain-group/fe-co-icon';
import { Card } from './components/card';
import { Footer } from './components/footer';
import * as styles from './allhomes-agent-recommendations.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesAgentRecommendations = _ref => {
  var reviews = _ref.reviews,
    url = _ref.url,
    heading = _ref.heading,
    brandingLevel = _ref.brandingLevel,
    overallRating = _ref.overallRating,
    reviewCount = _ref.reviewCount,
    isLoading = _ref.isLoading,
    isError = _ref.isError,
    hideButton = _ref.hideButton,
    loadMoreReviews = _ref.loadMoreReviews;
  var hasReviews = reviews.length > 0;
  var isGold = ['PLATINUM', 'GOLD'].includes(brandingLevel);
  return hasReviews ? ___EmotionJSX("section", {
    css: styles.container
  }, ___EmotionJSX("div", {
    css: styles.header
  }, ___EmotionJSX("div", {
    css: styles.heading
  }, heading), ___EmotionJSX("div", {
    css: styles.headingMobile
  }, "Reviews"), isGold && reviewCount > 0 && ___EmotionJSX(Fragment, null, ___EmotionJSX("div", {
    css: styles.headerDivider
  }), ___EmotionJSX(AverageStarRatingAndTotal, {
    averageRating: overallRating,
    totalReviews: reviewCount
  }))), reviews.map(review => ___EmotionJSX(Card, _extends({
    key: "".concat(review.title).concat(review.date)
  }, review))), ___EmotionJSX("div", {
    css: styles.loader({
      appear: isLoading && !isError
    })
  }, isLoading && !isError && ___EmotionJSX(Loader, null)), isError && ___EmotionJSX("div", {
    css: styles.errorMessage
  }, ___EmotionJSX(AlertIcon, {
    css: styles.alertIcon
  }), ___EmotionJSX("div", null, "More recommendations could not be loaded. Please try again later.")), ___EmotionJSX(Footer, {
    displayedReviews: reviews.length
    // Cater for scenario where reviews exist but review info does not
    // such as in case of old, but existent, DB reviews
    ,
    totalReviews: Math.max(reviewCount, reviews.length),
    url: url,
    disableButton: isLoading,
    hideButton: hideButton,
    onButtonClick: loadMoreReviews
  })) : null;
};
AllhomesAgentRecommendations.propTypes = {
  reviews: PropTypes.arrayOf(PropTypes.shape({})),
  url: PropTypes.string,
  heading: PropTypes.string,
  brandingLevel: PropTypes.oneOf(['GOLD', 'PLATINUM', 'NONE']),
  overallRating: PropTypes.number,
  reviewCount: PropTypes.number,
  isLoading: PropTypes.bool,
  isError: PropTypes.bool,
  hideButton: PropTypes.bool,
  loadMoreReviews: PropTypes.func
};
AllhomesAgentRecommendations.defaultProps = {
  reviews: [],
  url: '',
  heading: 'Reviews',
  brandingLevel: 'NONE',
  overallRating: 0,
  reviewCount: 0,
  isLoading: false,
  isError: false,
  hideButton: false,
  loadMoreReviews: () => {}
};
export { AllhomesAgentRecommendations };